/* eslint-disable max-len */
import { useEffect, useState } from 'react';
import { CalendarCustom } from '../../components';
import { DATE_YMD, DATE_YMD_ISO, SYSTEM_PATH } from '../../core/configs/constants';
import moment from 'moment';
import { useStore } from '../../core/utils/hook';
import Pagination from '../Courses/components/Pagination';

import './styles.scss';
import { useNavigate } from 'react-router-dom';

const NotifyListScreen = () => {
    // other
    const navigate = useNavigate();

    // store
    const { notifyStore: { notifies, getNotifies, pagingNotifiesListScreen, cleanNotifiesPaging } } = useStore();
    const [headerHeight, setHeaderHeight] = useState(0);
    useEffect(() => {
        const header = document.getElementById('header-site');
        if (!header) return;

        const updateHeight = () => {
            setHeaderHeight(header.offsetHeight);
        };

        // Follow initial height header
        updateHeight();

        // Follow resize header
        const resizeObserver = new ResizeObserver(updateHeight);
        resizeObserver.observe(header);

        // Follow resize window
        window.addEventListener('resize', updateHeight);

        return () => {
            resizeObserver.disconnect();
            window.removeEventListener('resize', updateHeight);
        };
    }, []);

    // state
    const [titleFilter, setTitleFilter] = useState();
    const [fromPublicDateFilter, setFromPublicDateFilter] = useState();
    const [toPublicDateFilter, setToPublicDateFilter] = useState();
    const [sortFilter, setSortFilter] = useState('DESC');

    // lifecycle
    useEffect(() => {
        fetchData();
        return () => {
            cleanNotifiesPaging();
        }
    }, [sortFilter])

    // function
    const fetchData = () => {
        getNotifies({
            ...titleFilter ? { title: titleFilter } : {},
            ...fromPublicDateFilter ? { fromDate: fromPublicDateFilter } : {},
            ...toPublicDateFilter ? { toDate: toPublicDateFilter } : {},
            ...sortFilter ? { sortDir: sortFilter } : {},
            forStudent: true
        });
    }

    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            fetchData();
        }
    };

    return (
        <div id='main' className='wrapper notify-list-screen'>
            <div className="bres-cus" 
                style={{ position: 'sticky', zIndex: 50, top: `${headerHeight}px`, left: '0', width: '100%', backgroundColor: '#FFF'}}>
                <div className='container'>
                    <ul>
                        <li>
                            <a href={SYSTEM_PATH.HOME}>
                                <img src='/images/icon-home.png' alt='' />
                            </a>
                        </li>
                        <li className='dash'>\</li>
                        <li>お知らせ一覧</li>
                    </ul>
                </div>
            </div>
            <div className='notify-list-container'>
                <div className='container'>
                    <div className='notify-list-title'>お知らせ一覧</div>
                    <div className='notify-list-filter'>
                        <div className='filter-submit'>
                            <div className='filter-submit-form'>
                                <div className='filter-submit-title'>
                                    <div className='title'>フリーワード</div>
                                    <input
                                        onKeyDown={handleKeyDown}
                                        className='input'
                                        onChange={(e) => setTitleFilter(e.target.value)} />
                                </div>
                                <div className='filter-submit-date'>
                                    <div className='title'>公開日</div>
                                    <div className='input'>
                                        <CalendarCustom
                                            date={fromPublicDateFilter}
                                            displayMode={'date'}
                                            onChange={date => {
                                                setFromPublicDateFilter(date ? moment(date).format(DATE_YMD_ISO) : null);
                                            }}
                                        />
                                        <div className='paginate'>~</div>
                                        <CalendarCustom
                                            date={toPublicDateFilter}
                                            displayMode={'date'}
                                            onChange={date => {
                                                setToPublicDateFilter(date ? moment(date).format(DATE_YMD_ISO) : null);
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className='filter-submit-button'>
                                <button type='button' onClick={fetchData}>検索</button>
                            </div>
                        </div>
                        <div className='filter-sort'>
                            <select className='filter-sort-select' onChange={(e) => {
                                setSortFilter(e.target.value);
                                cleanNotifiesPaging();
                            }}>
                                <option value='DESC'>新しい順</option>
                                <option value='ASC'>古い順</option>
                            </select>
                        </div>
                    </div>
                    <div className='notify-list-content'>
                        {
                            notifies?.length > 0 ? (
                                notifies.map((notify, index) => (
                                    <div key={index} className='notify-content-item cursor-pointer'
                                        onClick={() => navigate(`/notification/${notify.id}`)}>
                                        <div style={{marginRight: '7px'}}>
                                            <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M14.875 7.12796V2.83333C14.875 2.64547 14.8004 2.4653 14.6675 2.33247C14.5347 2.19963 14.3545 2.125 14.1667 2.125H13.4583C12.0565 3.52679 9.42296 4.31162 7.79167 4.68421V12.3158C9.42296 12.6884 12.0565 13.4732 13.4583 14.875H14.1667C14.3545 14.875 14.5347 14.8004 14.6675 14.6675C14.8004 14.5347 14.875 14.3545 14.875 14.1667V9.87204C15.1794 9.79377 15.4492 9.61649 15.6418 9.3681C15.8344 9.11971 15.9389 8.81432 15.9389 8.5C15.9389 8.18568 15.8344 7.88029 15.6418 7.6319C15.4492 7.38351 15.1794 7.20623 14.875 7.12796ZM3.54167 4.95833C3.16594 4.95833 2.80561 5.10759 2.53993 5.37327C2.27426 5.63894 2.125 5.99928 2.125 6.375V10.625C2.125 11.0007 2.27426 11.3611 2.53993 11.6267C2.80561 11.8924 3.16594 12.0417 3.54167 12.0417H4.25L4.95833 15.5833H6.375V4.95833H3.54167Z" fill="#F36D3B" />
                                            </svg>
                                        </div>

                                        <div className='notify-content-item-title line-clamp-1'>{notify.title}</div>
                                        <div className='notify-content-item-public'>{moment(notify.releaseDate).format(DATE_YMD)}</div>
                                    </div>
                                ))
                            ) : (
                                <div className='d-flex align-items-center justify-content-center min-height-200'>データはありません</div>
                            )
                        }
                        {notifies?.length > 0 &&
                            <Pagination paging={pagingNotifiesListScreen} onFetch={fetchData} />}
                    </div>
                </div>
            </div>
        </div>
    )    
};

export default NotifyListScreen;